import axios from 'axios';

// Rotas do NIMA consumidas pelo Usecore legado. O legado é servido pelo NIMA em /legacy
// (mesma origem), então a autenticação vem dos cookies de sessão do NIMA e do contexto
// assinado pelo bridge (cookie `auth`). Não usa o interceptor do Usecore: o token do
// Usecore não vale para essas rotas.
const NIMA_API_BASE_URL = (process.env.REACT_APP_NIMA_API_BASE_URL || '').replace(/\/$/, '');

const agendaUrl = (workspaceSlug, path) =>
  `${NIMA_API_BASE_URL}/api/w/${encodeURIComponent(workspaceSlug)}/agenda/${path}`;

const toNimaError = (error) => {
  if (error && error.response) {
    return {
      status: error.response.status,
      code: error.response.data && error.response.data.code,
      userFeedback: error.response.data && (error.response.data.error || error.response.data.message),
    };
  }
  return error;
};

export const getDayAppointments = async ({ workspaceSlug, date, scope, timezone }) => {
  try {
    const response = await axios.get(agendaUrl(workspaceSlug, 'usecore-day'), {
      params: { date, scope, timezone },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw toNimaError(error);
  }
};

const postAppointmentStatus = async ({ workspaceSlug, appointmentId, action }) => {
  try {
    const response = await axios.post(
      agendaUrl(workspaceSlug, `usecore-day/${encodeURIComponent(appointmentId)}/${action}`),
      {},
      { withCredentials: true },
    );
    return response.data;
  } catch (error) {
    throw toNimaError(error);
  }
};

/** Agendamento de origem passa para "Em atendimento". */
export const startAppointment = ({ workspaceSlug, appointmentId }) =>
  postAppointmentStatus({ workspaceSlug, appointmentId, action: 'start' });

/** Agendamento de origem passa para "Atendido", com a mesma regra de conclusão da agenda do NIMA. */
export const completeAppointment = ({ workspaceSlug, appointmentId }) =>
  postAppointmentStatus({ workspaceSlug, appointmentId, action: 'complete' });
